import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    interval: { type: Number, default: 300000 },
    url: { type: String, default: "/keepalive" }
  }

  connect() {
    this.startPinging();
  }

  disconnect() {
    this.stopPinging();
  }

  startPinging() {
    this.timer = setInterval(() => {
      this.ping();
    }, this.intervalValue);
  }

  stopPinging() {
    if (this.timer) clearInterval(this.timer);
  }

  async ping() {
    try {
      await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin'
      });
    } catch (error) {
      console.error('Keepalive ping failed:', error);
    }
  }
}
